// extracted by mini-css-extract-plugin
export default {"down-arrow":"AccordionComponent_down-arrow__qemrE"};